import Phaser from 'phaser';

import { GameAsset } from '../../services/asset-catalogue-service';
import { PileViewModel } from './pile-view-model';
import { SolitaireMainScene } from '../../scenes/solitaire-main-scene';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export abstract class PileView extends Phaser.GameObjects.Container {
  protected viewModel: PileViewModel;
  protected background: Phaser.GameObjects.Image;

  constructor(scene: SolitaireMainScene, x: number, y: number, viewModel: PileViewModel) {
    super(scene, x, y);

    this.viewModel = viewModel;

    const backgroundAsset = viewModel.backgroundAsset;
    this.background = scene.add.image(0, 0, backgroundAsset.type).setOrigin(0, 0);

    this.add([this.background]);
    this.setName(PileView.name);
    scene.add.existing(this);
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    this.resizeBackground(gameSizeMetrics, this.viewModel.backgroundAsset);
  }

  protected abstract resizeBackground(gameSizeMetrics: GameSizeMetrics, gameAsset: GameAsset): void;
}
